module.exports = __webpack_public_path__ + "static/img/1.捐血活動.a73c808.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/charitable-activities/1.捐血活動.jpg
// module id = XFr/
// module chunks = 100